import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  sidebarOpen: boolean;
  selectedWallet: 'real' | 'demo';
  activeModal: string | null;
}

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarOpen: false,
    selectedWallet: (localStorage.getItem('accountMode') as 'real' | 'demo') || 'real',
    activeModal: null as string | null,
  } as UIState,
  reducers: {
    toggleSidebar: (s) => { s.sidebarOpen = !s.sidebarOpen; },
    setSelectedWallet: (s, a: PayloadAction<'real' | 'demo'>) => { s.selectedWallet = a.payload; },
    openModal: (s, a: PayloadAction<string>) => { s.activeModal = a.payload; },
    closeModal: (s) => { s.activeModal = null; },
  },
});

export const { toggleSidebar, setSelectedWallet, openModal, closeModal } = uiSlice.actions;
export default uiSlice.reducer;
